module.exports = __webpack_public_path__ + "img/2x.ad6409b.jpg";